import { render } from "./GeneralNav.vue?vue&type=template&id=b87ace0c"
import script from "./GeneralNav.vue?vue&type=script&lang=js"
export * from "./GeneralNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__